import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch from "../../Components/Common/TableContainerSearch";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";
import exportToExcel from "../../Components/Common/exportToExcel";
import { showToast } from "../../Components/ToastNotification";
import { shareEmailReportThunk } from "../../slices/thunks";
import { useDispatch } from "react-redux";
import CommonLoading from "../../Components/Common/CommonLoading";

const CapitalGainReport = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  const dispatch = useDispatch();

  const token = userData?.token;
  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  const columns = useMemo(
    () => [
      {
        id: "scrip_name",
        Header: "Scrip Name",
        accessorKey: "scrip_name",

        meta: {
          style: { wordBreak: "break-word", minWidth: "15rem" },
        },
      },
      {
        id: "buy_qty",
        Header: "Buy Qty.",
        accessorKey: "buy_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "buy_rate",
        Header: "Buy Rate (₹)",
        accessorKey: "buy_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_qty",
        Header: "Sell Qty.",
        accessorKey: "sell_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_rate",
        Header: "Sell Rate (₹)",
        accessorKey: "sell_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "short_term",
        Header: "Short Term (₹)",
        accessorKey: "short_term",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "long_term",
        Header: "Long Term (₹)",
        accessorKey: "long_term",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "jobbing",
        Header: "Jobbing (₹)",
        accessorKey: "jobbing",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },

      // {
      //   id: "running_balance",
      //   Header: "Balance (₹)",
      //   accessorKey: "running_balance",
      //   headerTextAlign: "end",
      //   bodyTextAlign: "end",
      //   cell: (row) => {
      //     // console.log("row", row);
      //     return (
      //       <>
      //         {row?.getValue() > 0 ? (
      //           <span class=" text-success mb-0">
      //             {row?.getValue()
      //               ? parseFloat(row?.getValue()).toLocaleString("en-IN")
      //               : 0}
      //             {/* <i class="ms-1 ri-arrow-up-line align-middle"></i> */}
      //           </span>
      //         ) : row?.getValue() < 0 ? (
      //           <span class=" text-danger mb-0">
      //             {row?.getValue()
      //               ? parseFloat(row?.getValue()).toLocaleString("en-IN")
      //               : 0}{" "}
      //             {/* <i class="ms-1 ri-arrow-down-line align-middle"></i> */}
      //           </span>
      //         ) : (
      //           <span class="  mb-0">
      //             {row?.getValue()
      //               ? parseFloat(row?.getValue()).toLocaleString("en-IN")
      //               : 0}{" "}
      //           </span>
      //         )}
      //       </>
      //     );
      //   },
      // },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");

  const handleShareEmail = async () => {
    const body = {
      report_type: "long-short",
    };

    try {
      const response = await dispatch(
        shareEmailReportThunk({ body, token })
      ).unwrap();

      showToast("Report sent on your email successfully", "success");
    } catch (error) {
      console.error("Error submitting request:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    const fetchHoldings = async () => {
      setLoading(true);
      setError(null);
      // const holdingType = 1;
      try {
        const response = await axios.get("long-short-pnl", {
          // params: { holdingType }, // Pass holdingType as query param
          headers: {
            Authorization: `Bearer ${userData?.token}`, // Add Authorization header
            "Content-Type": "application/json",
          },
        });

        setSummary(response?.data?.summary);
        // console.log("here", response, response.data?.summary);
        setData(response.data?.items); // Update state with fetched data
        // setTimeout(() => {
        setLoading(false);
        // }, 2000);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        // setSummary(null)
        setError(err);
        setLoading(false);
      } finally {
        // setSummary(null)
        setLoading(false);
      }
    };

    fetchHoldings();
  }, []); // Runs when holdingType or token changes

  const handleDateRangeChange = async (values) => {
    // console.log("values",values)
    // setLoading(true);
    setError(null);
    // const holdingType = 1;
    try {
      const response = await axios.get("long-short-pnl", {
        params: { start_date: values?.start_date, end_date: values.end_date }, // Pass holdingType as query param
        headers: {
          Authorization: `Bearer ${userData?.token}`, // Add Authorization header
          "Content-Type": "application/json",
        },
      });

      // console.log("here", response);
      setSummary(response.data?.summary);
      setData(response.data?.items); // Update state with fetched data
      // setTimeout(() => {
      values.setTableLoading(false);
      // }, 2000);
    } catch (err) {
      console.error("Error fetching holdings:", err);
      // setSummary(null)
      setError(err);
      values.setTableLoading(false);
    } finally {
      values.setTableLoading(false);
      // setSummary(null)
    }
  };
  // const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  // const tableBody = data.map(
  //   (row) =>
  //     columns.map((col) =>
  //       row[col.accessorKey]
  //         ? typeof row[col.accessorKey] === "string"
  //           ? row[col.accessorKey]
  //           : row[col.accessorKey].toLocaleString("en-IN")
  //         : 0
  //     ) // Default to 0 if value is missing
  // );

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));

  const tableBody = data.map((row) =>
    columns.map((col) =>
      row[col.accessorKey]
        ? typeof row[col.accessorKey] === "string"
          ? row[col.accessorKey]
          : row[col.accessorKey].toLocaleString("en-IN")
        : 0
    )
  );

  // Define which columns to sum
  const sumColumns = ["short_term", "long_term", "jobbing"];

  const apiTotals = {
    short_term: summary?.total_short, // Replace with actual API data
    long_term: summary?.total_long, // Replace with actual API data
    jobbing: summary?.total_jobbing,
  };

  // Calculate totals only for "debit" and "credit"
  const totals = columns.map((col, index) => {
    if (index === 0) return "TOTAL"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  // Add totals row to the table
  tableBody.push(totals);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <Card className="mb-0">
              <CardHeader>
                <div className="m-0 p-0 d-flex align-items-center justify-content-between flex-wrap">
                  <div className="d-flex flex-column mb-2 mb-md-0">
                    <h3 className="m-0">Capital Gain Report</h3>
                    <p className="mb-0 mt-1 fs-14 fw-medium text-muted">
                      As on Date: {summary?.as_on_date}
                    </p>
                  </div>
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center ">
                    <div className="search-box   me-2 ">
                      <input
                        id="search-bar-0"
                        type="text"
                        style={{
                          backgroundColor: "#F1F4F7",
                          paddingTop: ".6rem",
                          paddingBottom: ".6rem",
                        }}
                        className="form-control border-0 search "
                        placeholder="Search by Scrip Name"
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                      />
                      <i className="bx bx-search-alt search-icon-new"></i>
                    </div>
                    <Dropdown
                      isOpen={isTopPageDropdown}
                      toggle={toggleDropdown}
                      className={`card-header-dropdown ${
                        data?.length === 0 ? "disabled-dropdown_export" : ""
                      }`}
                    >
                      <DropdownToggle
                        tag="a"
                        className="text-reset dropdown-btn"
                        role="button"
                        color="success"
                      >
                        <Button
                          type="button"
                          color="success"
                          className="export_btn_new"
                        >
                          Export<i className="ms-1 bx bx-caret-down"></i>
                        </Button>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-end">
                        <DropdownItem
                          onClick={() =>
                            exportToPDF(
                              "Capital Gain Report",
                              userData,
                              ``,
                              `As on Date: ${summary?.as_on_date}`,
                              tableHeaders,
                              tableBody
                            )
                          }
                        >
                          Export as PDF
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            exportToExcel(
                              "Capital Gain Report",
                              userData,
                              ``,
                              `As on Date: ${summary?.as_on_date}`,
                              tableHeaders,
                              tableBody,
                              "",
                              [],
                              []
                            )
                          }
                        >
                          Export Excel
                        </DropdownItem>
                        <DropdownItem onClick={handleShareEmail}>
                          Share on Email
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <TableContainerSearch
                  footer={true}
                  summary={summary}
                  columns={columns}
                  data={data}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                />
              </CardBody>
            </Card>
          )}
          {/* <BreadCrumb title="Dashboard" pageTitle="Dashboards" /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CapitalGainReport;
